import React, { Component } from 'react';

import { Admin, Resource, ListGuesser } from 'react-admin';
import jsonServerProvider from 'ra-data-json-server';

import authProvider from "../../../model/providers/auth/auth-provider.js";
import dataProvider from "../../../model/providers/data/data-provider.js";



import Routes from './routes.js';
import { MyLayout }  from './layout.js';

import Home from '../home/home.js';


import {AccountList} from "../../components/account/accounts.js";
import {AccountCreate, AccountShow, AccountEdit} from "../../components/account/account.js";

import {CryptoKeyList} from "../../components/key/keys.js";
import {CryptoKeyShow} from "../../components/key/key.js";

import {ERC20TokenList} from "../../components/erc20token/erc20tokens.js";
import {ERC20TokenCreate, ERC20TokenShow, ERC20TokenEdit} from "../../components/erc20token/erc20token.js";

import {ProfileShow} from "../../components/profile/profile.js";


import {TransactionList} from "../../components/transaction/transactions.js";
import {TransactionShow} from "../../components/transaction/transaction.js";

import {LocalVaultList} from "../../components/local-vault/local-vaults.js";
import {LocalVaultShow} from "../../components/local-vault/local-vault.js";


class Root extends React.Component {
	constructor(props) {
		super(props);
		
		this.app = this.props.app;

		//connect the data provider to the REST endpoint
		//this.dataProvider = jsonServerProvider('https://jsonplaceholder.typicode.com');
		this.dataProvider = dataProvider;
	}

	// render
	render() {
		return (
			<Admin customRoutes={Routes} layout={MyLayout} dashboard={Home} dataProvider={this.dataProvider} authProvider={authProvider}>
				<Resource name="local-vaults" list={LocalVaultList} show={LocalVaultShow} />
				<Resource name="accounts" list={AccountList} edit={AccountEdit} show={AccountShow} create={AccountCreate} />
				<Resource name="cryptoKeys" list={CryptoKeyList} show={CryptoKeyShow} />
				<Resource name="transactions" list={TransactionList} show={TransactionShow} />
				<Resource name="erc20tokens" list={ERC20TokenList} edit={ERC20TokenEdit} show={ERC20TokenShow} create={ERC20TokenCreate} />
				<Resource name="profile"  show={ProfileShow} />
			</Admin>
		);
	}
		
	
}

export default Root;